export const ru = {
    transaction_history: 'История транзакций',
};
